import { useTranslation } from 'react-i18next'
import { cn } from '@/lib/utils'
import { parseDate } from '@/lib/utils/date'
import type { ChallengePhase, ClubChallenge } from '@/types'

export function formatPeriod(
  challenge: Pick<ClubChallenge, 'starts_on' | 'ends_on'>,
  language: string
) {
  const format = new Intl.DateTimeFormat(language, {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
  })
  return `${format.format(parseDate(challenge.starts_on))} – ${format.format(parseDate(challenge.ends_on))}`
}

export function formatDay(date: string, language: string) {
  return new Intl.DateTimeFormat(language, { day: 'numeric', month: 'short' }).format(
    parseDate(date)
  )
}

export function PhaseBadge({ phase }: { phase: ChallengePhase }) {
  const { t } = useTranslation()
  const styles: Record<ChallengePhase, string> = {
    upcoming: 'bg-info/10 text-info',
    active: 'bg-success/10 text-success',
    finished: 'bg-muted text-muted-foreground',
  }
  return (
    <span className={cn('shrink-0 rounded-full px-2 py-0.5 text-xs font-medium', styles[phase])}>
      {t(`challenges.phase.${phase}`)}
    </span>
  )
}
